.loadingSpinner {
  width: 16px;
  height: 16px;
}
